<div class="container">
  <img src="imgs/icon.png" class="logo-icon">
  <div class="title">
    MyMindLog
  </div>
  <div class="sub-title">
    {{'associate-to-psychologist.subtitle' | translate}}
  </div>  
  <div class="form-container">

    <div class="psychologist-container">
      <div class="instructions">
        <span>
          {{'associate-to-psychologist.instruction_1' | translate}}
        </span>
        <span>
          {{'associate-to-psychologist.instruction_2' | translate}}
        </span>
        <span>
          {{'associate-to-psychologist.instruction_3' | translate}}
        </span>
      </div>
      <div class="request-container">
        <p>{{'associate-to-psychologist.request' | translate}}</p>
        <div class="psychologist-selected" (click)="openPsychologistsToSelect()">
          @if (pyscholosgistSelected()) {
            <mat-icon>badge</mat-icon>
            <span>{{pyscholosgistSelected()?.first_name + ' ' + pyscholosgistSelected()?.last_name}}</span>
          }@else {
            <mat-icon>filter_list</mat-icon>
            <span>{{'associate-to-psychologist.select' | translate}}</span>
          }
        </div>
      </div>
    </div>

    <div class="actions-container">
      <app-button 
        [buttonLabel]="'buttons.cancel' | translate"
        [buttonType]="BUTTON_TYPES.OUTLINED" 
        [buttonDisabled]="false"
        (click)="cancel()">
      </app-button>
      
      <app-button
        [buttonLabel]="'buttons.request' | translate"
        [buttonType]="BUTTON_TYPES.REGULAR" 
        [buttonDisabled]="!isPsychologistSelected()"
        (click)="requestAssociation()">
      </app-button>
    </div>
  </div>
</div>